import { render, staticRenderFns } from "./CoachingProfileDetails.vue?vue&type=template&id=27c835ea"
import script from "./CoachingProfileDetails.vue?vue&type=script&lang=js"
export * from "./CoachingProfileDetails.vue?vue&type=script&lang=js"
import style0 from "./CoachingProfileDetails.vue?vue&type=style&index=0&id=27c835ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports